import React from "react";
import {withStyles, Dialog, DialogActions, DialogContent, DialogTitle, Box, IconButton, Typography, Button, CircularProgress} from "@material-ui/core";
import {Close as CloseIcon} from "@material-ui/icons";
import PropTypes from "prop-types";

import {styles} from "./styles";

export const ModalDialog = withStyles(styles)((props) => {
  const {
    classes, open, title, maxWidth, minWidth, onClose, onOk, okLabel,
    disabledOk, additionalAction, loading, error, noActions
  } = props;

  return (
    <Dialog open={open} maxWidth={maxWidth || 'lg'} PaperProps={{style: {minWidth}}} className={classes.dialog}>
      <DialogTitle disableTypography className={classes.titleWrapper}>
        <Typography variant="h3" className={classes.title}>{title}</Typography>
        <IconButton className={classes.closeIcon} onClick={() => onClose()}>
          <CloseIcon color="inherit" fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {props.children}
      </DialogContent>
      {!noActions && (
        <DialogActions className={classes.actionsWrapper}>
          {additionalAction && (
            <Button
              variant={additionalAction.variant || "outlined"}
              disableElevation
              className={classes.button + ' ' + additionalAction.className}
              onClick={additionalAction.onClick}
              {...additionalAction}
            >
              {additionalAction.label || "OK"}
            </Button>
          )}
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            className={classes.button}
            onClick={() => onClose()}
          >
            Cancel
          </Button>
          {loading && (
            <Button variant="outlined" disableElevation color="secondary" className={classes.button}>
              <CircularProgress color="inherit" size={23} />
            </Button>
          )}
          {!loading && (
            <Button
              variant="contained"
              disableElevation
              color="primary"
              disabled={disabledOk}
              className={classes.button}
              onClick={() => onOk()}
            >
              {okLabel || "OK"}
            </Button>
          )}
        </DialogActions>
      )}
      {error && (
        <Box align="center" pb={2} className={classes.error}>
          {typeof error === 'object' && error.map(er => (<Box key={er}>{er}</Box>))}
          {typeof error === 'string' && error}
        </Box>
      )}
    </Dialog>
  )
})

ModalDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
  okLabel: PropTypes.string,
  disabledOk: PropTypes.bool,
  additionalAction: PropTypes.any,
  loading: PropTypes.bool,
  error: PropTypes.any,
}
